import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../lib/LanguageContext';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-105">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/oEt3xx7D8nhsjkcxsfgcaM/lisa.jpg")',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    }} data-id="element-106">
        <div className="absolute inset-0 bg-teal-950/80 backdrop-blur-[2px]" data-id="element-107"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center text-center px-4 max-w-4xl mx-auto pt-24 pb-20" data-id="element-108">
        <div className="w-56 md:w-72 lg:w-80 mb-4 flex-shrink-0" data-id="element-109">
          <motion.img initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          ease: 'easeOut'
        }} src="https://cdn.magicpatterns.com/uploads/9kPEnQk3qpn3pap79A2DDd/lisa_logo.jpg" alt="Cheers by Lisa Logo" className="w-full rounded-full shadow-2xl shadow-[#D4A843]/20" style={{
          maskImage: 'radial-gradient(circle, black 55%, transparent 75%)',
          WebkitMaskImage: 'radial-gradient(circle, black 55%, transparent 75%)'
        }} data-id="element-110" />
        </div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-4xl md:text-5xl lg:text-6xl font-serif text-white mb-6 leading-tight" data-id="element-111">
          {t('hero.title.part1')} <br className="hidden md:block" data-id="element-112" />
          <span className="text-[#D4A843] italic" data-id="element-113">{t('hero.title.part2')}</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="text-lg md:text-xl text-teal-50 mb-10 max-w-2xl font-light leading-relaxed" data-id="element-114">
          {t('hero.subtitle')}
        </motion.p>

        <motion.button initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.7
      }} onClick={() => {
        document.getElementById('booking')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} className="bg-[#D4A843] text-white px-10 py-4 rounded-none font-semibold tracking-widest uppercase hover:bg-white hover:text-[#0D9488] transition-colors duration-300 shadow-[0_0_20px_rgba(212,168,67,0.3)]" data-id="element-115">
          {t('hero.cta')}
        </motion.button>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center" data-id="element-116">
        <span className="text-white/70 text-sm tracking-widest uppercase mb-2" data-id="element-117">
          {t('hero.scroll')}
        </span>
        <div className="w-[1px] h-12 bg-gradient-to-b from-[#D4A843] to-transparent" data-id="element-118"></div>
      </motion.div>
    </section>;
}